interface SubmissionCodePanelProps {
  code: string;
}

export default function SubmissionCodePanel({ code }: SubmissionCodePanelProps) {
  return (
    <section className='bg-white rounded-2xl p-6 shadow-card-sm'>
      <h2 className='font-semibold text-apple-near-black text-[1.125rem] mb-4'>提交代码</h2>
      <pre className='bg-apple-light-gray rounded-xl px-4 py-4 text-[0.8125rem] text-apple-near-black overflow-x-auto whitespace-pre-wrap break-words'>
        {code || '无代码内容'}
      </pre>
    </section>
  );
}
